<template>
  <div class="bpjs-page">
        <PageHeader icon="fas fa-clinic-medical">
      <template #title>
        BPJS Kesehatan
      </template>
      <template #subtitle>
        Kelola verifikasi peserta, pelayanan PCare, rujukan, dan antrean Mobile JKN.
      </template>
      <template #actions>
        <button 
                type="button" 
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                @click="$router.push('/bpjs/peserta')"
              >
                <i class="fas fa-search"></i><span>Cek Peserta</span>
              </button>
      </template>
    </PageHeader>

    <div class="row">
      <div v-for="item in modules" :key="item.title" class="col-sm-6 col-xl-3 mb-5">
        <b-card class="bpjs-card bpjs-kpi h-100">
          <div class="d-flex align-items-start justify-content-between">
            <span class="bpjs-kpi-icon"><i :class="item.icon"></i></span>
            <span class="badge badge-light-success">Aktif</span>
          </div>
          <h5 class="font-weight-bolder mt-4 mb-1">{{ item.title }}</h5>
          <div class="text-muted">{{ item.caption }}</div>
        </b-card>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-8 mb-5">
        <b-card class="bpjs-card h-100" title="Alur Pelayanan BPJS">
          <div v-for="(step, index) in steps" :key="step.title" class="d-flex py-3" :class="{ 'border-bottom': index < steps.length - 1 }">
            <div class="bpjs-kpi-icon mr-4">{{ index + 1 }}</div>
            <div>
              <div class="font-weight-bolder">{{ step.title }}</div>
              <div class="text-muted">{{ step.text }}</div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-lg-4 mb-5">
        <b-card class="bpjs-card h-100" title="Status Integrasi">
          <div v-if="loading" class="text-muted d-flex align-items-center mt-4">
            <b-spinner small class="mr-3 text-primary" />Memeriksa koneksi...
          </div>
          <template v-else>
            <div 
              class="custom-alert mb-6"
              :class="configured ? 'custom-alert-success' : 'custom-alert-danger'"
              style="padding: 16px; margin-top: 24px;"
            >
              <div class="custom-alert-badge">
                <i class="fas" :class="configured ? 'fa-check-circle' : 'fa-times-circle'" style="font-size: 11px;"></i>
                {{ configured ? "Terhubung" : "Belum Terhubung" }}
              </div>
              <div class="d-flex flex-column w-100 text-center align-items-center mt-2">
                <span class="font-weight-bolder text-dark mb-1" style="font-size: 14px;">
                  {{ configured ? "Integrasi Aktif" : "Menunggu Konfigurasi" }}
                </span>
                <span class="text-dark-75 font-weight-bold" style="font-size: 12px; line-height: 1.4;">
                  {{ statusMessage }}
                </span>
              </div>
            </div>
            <b-button :variant="configured ? 'outline-success' : 'primary'" block class="font-weight-bold" to="/bpjs/pengaturan">
              <i class="fas mr-2" :class="configured ? 'fa-cog' : 'fa-plug'"></i>
              {{ configured ? "Kelola Pengaturan" : "Hubungkan BPJS" }}
            </b-button>
          </template>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  data: () => ({
    loading: true,
    configured: false,
    statusMessage: "",
    modules: [
      { title: "Peserta", caption: "Validasi NIK & kartu", icon: "fas fa-id-card" },
      { title: "PCare", caption: "Catat kunjungan FKTP", icon: "fas fa-notes-medical" },
      { title: "Rujukan", caption: "Rujukan ke FKRTL", icon: "fas fa-share-square" },
      { title: "Mobile JKN", caption: "Sinkronisasi antrean", icon: "fas fa-mobile-alt" },
    ],
    steps: [
      { title: "Verifikasi peserta", text: "Pastikan kepesertaan aktif sebelum pelayanan dimulai." },
      { title: "Catat kunjungan", text: "Kirim data pelayanan klinik ke PCare setelah pemeriksaan." },
      { title: "Buat rujukan bila perlu", text: "Terbitkan rujukan FKRTL berdasarkan hasil pemeriksaan dokter." },
      { title: "Perbarui antrean", text: "Sinkronkan progres pelayanan pasien Mobile JKN." },
    ],
  }),
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "BPJS Kesehatan" }, { title: "Dashboard" }]);
    this.loadStatus();
  },
  methods: {
    async loadStatus() {
      try {
        const response = await ApiService.get("bpjs/settings");
        const data = response.data || {};
        this.configured = Boolean(data.is_configured || (data.data && data.data.is_configured));
        this.statusMessage = data.message || "Status integrasi berhasil diperiksa.";
      } catch (error) {
        this.statusMessage = "Status layanan belum dapat diperiksa.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
